export default __webpack_public_path__ + "static/25-a7711f832ee42fe8193d937ada63d46f.png";